import { render } from "./AllDossierDeclasser.vue?vue&type=template&id=1b7ff2b5"
import script from "./AllDossierDeclasser.vue?vue&type=script&lang=js"
export * from "./AllDossierDeclasser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__